import type { RateLimitAction } from '@/graphql.types'

// Temporarily hidden from users — flip to true to show rate limiting again
// (app/static site networking sections and the load balancer networking tab)
export const IS_RATE_LIMITING_ENABLED = false

export const RATE_LIMIT_REQUESTS_PER_MINUTE = 100

type RateLimitActionInfo = {
  label: string
  description: string
}

export const rateLimitActions: RateLimitAction[] = [
  'CHALLENGE',
  'THROTTLE',
  'BAN',
]

export const rateLimitActionInfo: Record<RateLimitAction, RateLimitActionInfo> =
  {
    CHALLENGE: {
      label: 'Challenge',
      description:
        'Visitors that exceed the limit must pass a Cloudflare managed challenge to continue. Mitigation lasts 5 minutes.',
    },
    THROTTLE: {
      label: 'Throttle',
      description:
        'Requests over the limit are blocked only while the rate stays above the limit. Traffic resumes as soon as the rate drops.',
    },
    BAN: {
      label: 'Ban',
      description: 'Visitors that exceed the limit are blocked for 5 minutes.',
    },
  }
